
  import Component from "vue-class-component";

  import EmployeeService from "@/service/EmployeeService";
  import {Prop, Vue, Watch} from "vue-property-decorator";
  import Employee from "@/model/Employee";
  import EmployeeName from "@/model/EmployeeName";

  @Component
  export default class WorklogDetailsDialogEmployeeField extends Vue {
    @Prop({default: () => new EmployeeName()})
    public value: EmployeeName;

    @Prop({default: false})
    public disabled: boolean;

    @Prop({default: () => []})
    public errorMessages: Array<string>;

    private loading = false;
    private search = "";
    private searchItems: Array<EmployeeName> = [];
    private typeTimeout = 200;

    @Watch("search")
    onSearchChanged(term: string) {
      clearTimeout(this.typeTimeout);

      if (term != null && term.length > 2) {
        this.typeTimeout = setTimeout(() => {
          term && this.findEmployees(term);
        }, this.typeTimeout);
      }
    }

    findEmployees(term: string) {
      this.loading = true;

      EmployeeService.lookupEmployeeNamesV3(term)
        .then(employees => {
          // The selection is keyed by the employee number; creating a worklog sends the employee's uuid
          this.searchItems = employees
            .map(employeeName => Object.assign(employeeName, {id: employeeName.employeeId}));
        })
        .finally(() => {
          this.loading = false;
        });
    }

    employeeSelected(item: Employee) {
      this.search = "";
      this.$emit("input", item);
    }
  }
